"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  MALE: 'male',
  FEMALE: 'female',
  UNSPECIFIED: 'unspecified'
};
exports.default = _default;